export enum LogisticLableUserType {
  Sender = 'Sender',
  Recepient = 'Recepient',
}
